import OutboundSyncLog from '@/models/OutboundSyncLog';

export default class OutboundSyncLogRepository {
  public static getAll(): OutboundSyncLog[] {
    return OutboundSyncLog.query().orderBy('sentAt', 'desc').get();
  }
}